import { memo } from 'react';
import { Button, Table } from 'rsuite';
import styles from './SegmentsArea.module.scss';
import { SegmentsTable } from '../SegmentsTable';
import { useSetupISACustomSegmentsStore } from '../../SetupISACustomSegments.store';
import { useGetCustomSegmentTableList } from '../../hooks/useGetCustomSegmentTableList';

const Pagination = memo(Table.Pagination);

const lengthMenu = [
  {
    value: 10,
    label: 10,
  },
  {
    value: 20,
    label: 20,
  },
];

export const SegmentsArea = () => {
  const { setSetupISACustomSegmentsState, setCreateEditSegmentOpenModal, setEditSegmentData, customSegmentData } = useSetupISACustomSegmentsStore();
  const { handleChangeCustomSegmentPage, handleChangeCustomSegmentSort, handleChangeCustomSegmentLength } = useGetCustomSegmentTableList();

  const dataPagination = customSegmentData?.data?.page;

  const handleOpenCreateSegmentModal = () => {
    setCreateEditSegmentOpenModal('create', true);
  };

  const handleOpenEditSegmentModal = (id: number) => {
    setEditSegmentData(id);
  };

  const handleOpenRemoveSegmentModal = (id: number) => {
    setSetupISACustomSegmentsState('openModalRemoveSegment', true);
    setSetupISACustomSegmentsState('selectedSegmentID', id);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div>
          <h2 className={styles.title}>Seus segmentos</h2>
          <p className={styles.subtitle}>Confira os segmentos que já foram criados.</p>
        </div>
        <Button appearance="primary" onClick={handleOpenCreateSegmentModal} className={styles['create-segment-btn']}>
          Criar novo segmento
        </Button>
      </div>
      <SegmentsTable
        data={customSegmentData}
        onClickEdit={handleOpenEditSegmentModal}
        onClickMore={handleOpenRemoveSegmentModal}
        onSort={handleChangeCustomSegmentSort}
      />
      <Pagination
        className={styles.pagination}
        total={dataPagination?.totalElements}
        displayLength={dataPagination?.size}
        activePage={dataPagination?.number + 1}
        onChangePage={handleChangeCustomSegmentPage}
        onChangeLength={handleChangeCustomSegmentLength}
        lengthMenu={lengthMenu}
      />
    </div>
  );
};
